// A17.29 status page — module-local data layer. Admin manages components
// (/admin/status-components); the public /status derives overall health from
// components + open incidents (reuses the incident subsystem).
import { api } from '@/lib/api'

export interface StatusComponent {
  id: number
  name: string
  description: string
  status: string
  position: number
}
export interface ActiveIncident {
  id: number
  title: string
  severity: string
  status: string
  started_at: string
}
export interface PublicStatus {
  overall: string
  components: StatusComponent[]
  active_incidents: ActiveIncident[]
}

const opt = (s?: AbortSignal) => (s ? { signal: s } : undefined)

export const fetchComponents = (s?: AbortSignal) =>
  api.get<{ components: StatusComponent[] }>('/admin/status-components', opt(s)).then((d) => d.components ?? [])
export const createComponent = (name: string, description: string) =>
  api.post<{ id: number }>('/admin/status-components', { name, description })
export const updateComponent = (id: number, body: Partial<{ name: string; description: string; status: string; position: number }>) =>
  api.put(`/admin/status-components/${id}`, body)
export const deleteComponent = (id: number) => api.del(`/admin/status-components/${id}`)
export const fetchPublicStatus = (s?: AbortSignal) => api.get<PublicStatus>('/status', opt(s))

export const COMPONENT_STATUSES = [
  { key: 'operational', label: 'Работает', color: 'text-success', dot: 'bg-success' },
  { key: 'maintenance', label: 'Обслуживание', color: 'text-accent', dot: 'bg-accent' },
  { key: 'degraded', label: 'Снижена', color: 'text-warning', dot: 'bg-warning' },
  { key: 'partial_outage', label: 'Частичный сбой', color: 'text-warning', dot: 'bg-warning' },
  { key: 'major_outage', label: 'Серьёзный сбой', color: 'text-danger', dot: 'bg-danger' },
] as const

export function statusMeta(key: string) {
  return COMPONENT_STATUSES.find((s) => s.key === key) ?? COMPONENT_STATUSES[0]
}

export const SP_STR = {
  title: 'Страница статуса',
  desc: 'Компоненты сервиса + общий статус (учитывает открытые инциденты)',
  overall: 'Общий статус',
  components: 'Компоненты',
  activeIncidents: 'Открытые инциденты',
  newComponent: 'Новый компонент',
  name: 'Название',
  description: 'Описание',
  add: 'Добавить',
  delete: 'Удалить',
  none: 'Нет компонентов — добавьте первый',
  noIncidents: 'Нет открытых инцидентов',
  done: 'Готово',
  failed: 'Ошибка',
  refresh: 'Обновить',
} as const
